import { reactive, ref } from "vue";
// import { reactive, ref, defineAsyncComponent } from "vue";

// import CryptoJS from "crypto-js";
import moment from "moment-timezone";

import Swal from 'sweetalert2';

const swalert = Swal.mixin({
    width: '50rem',
    // iconColor: 'rgb(var(--bs-custom-rgb))',
    // customClass: {
    //     // popup: 'mt-5 bg-custom text-light',
    //     // timerProgressBar: 'bg-custom',
    //     confirmButton: "btn btn-primary p-3",
    //     cancelButton: "btn btn-secondary p-3",
    //     closeButton: "btn btn-secondary p-3",
    //     denyButton: "btn btn-secondary p-3",
    // },
    buttonsStyling: false
});


export const _G = {
    csrfName: "",
    csrfHash: "",
    token: "",

    ajaxBaseUrl: {
        "default": `http://localhost:8000`,
    },

    ajaxHeaders: reactive({}),

    mediaURL: `http://localhost:8000/media/`,

    main_host: 'example.az',

    theme: 'custom',

    defaultSelectedMenu: "index",

    defaultPage: "system_modules/user/Users",

    projectName: "Project Name",
    footerPowered: '<a href="https://example.az" class="footerClass" target="_blank">Organization Name</a> © 2023',
    footerDescription: 'Footer Description',

    ignored_routes: [
        "notfound_full",
        "notfound",
        "notperm",
        "login",
        "profile",
        "404",
        "about",
    ],

    currentRoute: "",
    current: reactive({
        page: "",
        data: {}
    }),
    columnMaxConstraints: 3,

    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 25, 50, 100, 500],

    uploadedFileSize: 52428800,

    showFilterAfterLength: 15,

    toastLifeTime: 2000,

    lang: ref({}),
    lang_list: ref([]),

    userImage: ref(''),

    systemData: reactive({"timezone": {"value": "Asia/Baku", "type": "text"}}),

    isTheme: (theme) => {
        let themes = [
            'custom',
            'primary',
            'secondary',
            'warning',
            'danger',
            'success',
            'info',
            'dark',
        ];
        return themes.includes(theme);
    },

    datetime_format: {
        'pg_datetime': 'YYYY-MM-DD HH:mm:ss',
        'datetime': 'DD.MM.YYYY HH:mm:ss',
        'date': 'DD.MM.YYYY',
        'year': 'YYYY',
        'month': 'MM.YYYY',
        'time': 'HH:mm:ss',
        'hourminute': 'HH:mm',
        'for_file': 'DD.MM.YYYY__HH.mm.ss',
        'for_print': 'DD.MMM.YYYY HH:mm',
        'datetime_as_pg': 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    },

    modal: reactive({
        page: null,
        data: null
    }),

    dynModal: {
        lastDialog: reactive({}),
        components: reactive([
            // {
            //     _id: "BUY6Drn9e1",
            //     component: 'Foo',
            //     prop: {
            //         show: true,
            //     },
            //     callback: () => {}
            //     // defineAsyncComponent({
            //     //     loader: () => import(`@/components/modal/Foo`),
            //     //     errorComponent:
            //     //         defineAsyncComponent(() =>
            //     //             import('@/pages/NotFound')
            //     //         ),
            //     //     // timeout: 3000,
            //     //     // suspensible: false,
            //     // })
            // }
        ])
    },

    showModal: (opt) => {
        if(opt){
            let dlgItem = Object.assign(opt, {
                // component: `ModalController`,
                _id: _G.uniqueId(),
                // show: true,
                index: _G.dynModal.components.length,
                closeOnEscape: opt.closeOnEscape !== undefined ? opt.closeOnEscape : true,
            });
            _G.dynModal.components.push(dlgItem);
            _G.activateModal(dlgItem);
        }
    },
    activateModal: (el) => {
        _G.dynModal.components.forEach((e) => {
            if( e._id == el._id ){
                e.dactive = true;
                _G.dynModal.lastDialog = e;
            }
            else{
                e.dactive = false;
            }
        });
    },
    closeModal: (el) => {
        if( el !== undefined )
        {
            _G.dynModal.components.forEach((e, i) => {
                if( e._id == el._id ){
                    _G.dynModal.components.splice(i, 1);
                }
            });
        }
        else{
            return false;
        }
        // _G.activateModal(_G.dynModal.components[_G.dynModal.components.length-1]);
    },
    closeModalAll: () => {
        _G.dynModal.components.forEach((e, i) => {
            // e.hide();
            _G.dynModal.components.splice(i, 1);
        });

        _G.dynModal.lastDialog = reactive({});
        _G.dynModal.components = reactive([]);
    },
    // showModal: (opt) => {
    //     if(opt){
    //         _G.modal.page = opt.page || '';
    //         _G.modal.data = opt || {};
    //     }
    // },
    // closeModal: () => {
    //     _G.modal.page = null;
    //     _G.modal.data = null;
    // },

    alert: reactive({
        ref: null,
        class: {
            success: 'success',
            error: 'error',
            info: 'info',
            warning: 'warning',
            confirm: 'warning',
            question: 'question',
        },
        bgclass: {
            success: 'bg-success-subtle',
            error: 'bg-danger-subtle',
            info: 'bg-info-subtle',
            warning: 'bg-warning-subtle',
            confirm: 'bg-light-subtle',
        },
        obj: {},
        init: (opt) => {
            _G.alert.obj = {
                // clean: opt.clean !== undefined ? opt.clean : true,
                severity: _G.alert.obj.severity !== undefined ? _G.alert.obj.severity : 'success',
                msg: opt.msg !== undefined ? opt.msg : '',
                title: opt.title !== undefined ? opt.title : '',
                life: (_G.alert.obj.severity === 'confirm') ? undefined : (opt.life !== undefined ? opt.life : _G.toastLifeTime),
                toast: opt.toast !== undefined ? opt.toast : false,
                position: opt.position !== undefined ? opt.position : (opt.toast !== undefined && opt.toast ? 'top-end' : 'center'),
                icon: opt.icon !== undefined ? opt.icon : _G.alert.class[_G.alert.obj.severity],
                background: opt.background !== undefined ? opt.background : undefined, //'#fff url(/assets/images/logo.png) no-repeat',
                class: opt.class !== undefined ? opt.class : '',
                html: opt.html !== undefined ? opt.html : '',

                yesButtonClass: opt.yesButtonClass !== undefined ? opt.yesButtonClass : undefined,
                yesIcon: opt.yesIcon !== undefined ? `<i class="${opt.yesIcon} me-2"></i>` : '',
                yesTitle: opt.yesTitle !== undefined ? opt.yesTitle : 'yes',
                yes: opt.yes !== undefined ? opt.yes : () => { },
                noButtonClass: opt.noButtonClass !== undefined ? opt.noButtonClass : undefined,
                noIcon: opt.noIcon !== undefined ? `<i class="${opt.noIcon} me-2"></i>` : '',
                noTitle: opt.noTitle !== undefined ? opt.noTitle : 'no',
                no: opt.no !== undefined ? opt.no : () => { },
                onclose: opt.onclose !== undefined ? opt.onclose : () => { },
            };

            // _G.alert.obj.icon = (opt.icon !== undefined ? opt.icon : (_G.alert.obj.icon !== undefined ? _G.alert.obj.icon : _G.alert.class[_G.alert.obj.severity]));
        },
        notify: (opt) => {
            if (opt instanceof Object === false) {
                let opto = {msg: opt};
                // opto.toast = _G.alert.obj.toast !== undefined ? _G.alert.obj.toast : undefined;
                // opto.position = _G.alert.obj.position !== undefined ? _G.alert.obj.position : undefined;

                _G.alert.init(opto);
                // _G.alert.obj.msg = opt;
            }
            else {
                // opt.toast = _G.alert.obj.toast !== undefined ? _G.alert.obj.toast : undefined;
                // opt.position = _G.alert.obj.position !== undefined ? _G.alert.obj.position : undefined;

                _G.alert.init(opt);
            }
            // let timerInterval;
            return swalert.fire({
                animation: true,
                title: _G.alert.obj.title,
                html: _G.alert.obj.html ? _G.alert.obj.html : _G.alert.obj.msg,
                icon: _G.alert.obj.icon,
                toast: _G.alert.obj.toast,
                position: _G.alert.obj.position,

                customClass: {
                    popup: _G.alert.obj.class + ' ' +  (_G.alert.obj.toast !== undefined && _G.alert.obj.toast !== false ? `mt-5 ${_G.alert.bgclass[_G.alert.obj.severity]}` : ''),
                    confirmButton: "btn btn-primary px-4 me-3",
                    cancelButton: "btn btn-secondary px-4",
                    closeButton: "btn bg-secondary bg-opacity-10 rounded-0 p-3 fs-4",
                    denyButton: "btn btn-secondary p-3",
                },

                timer: _G.alert.obj.life !== undefined ? _G.alert.obj.life : (_G.alert.obj.toast !== undefined && _G.alert.obj.toast !== false ?  2000 : _G.alert.obj.life),
                timerProgressBar: _G.alert.obj.toast !== undefined && _G.alert.obj.toast !== false ? _G.alert.obj.toast : true,

                showConfirmButton: _G.alert.obj.severity == 'confirm' ? true : false,
                showCancelButton: _G.alert.obj.severity == 'confirm' ? true : false,
                // showConfirmButton: typeof _G.alert.obj.yes === 'function' ? true : false,
                // showCancelButton: typeof _G.alert.obj.no === 'function' ? true : false,
                confirmButtonText: _G.alert.obj.yesIcon + _G.alert.obj.yesTitle,
                cancelButtonText: _G.alert.obj.noIcon + _G.alert.obj.noTitle,
                showCloseButton: true,
                // width: '40%',
                // padding: "0rem",
                // margin: '40px 40px 0 0',
                // color: "#716add",
                // imageWidth: 60,
                // imageHeight: 60,
                background: _G.alert.obj.background,
                // backdrop: `
                //     rgba(0,0,123,0.4)
                //     url("/images/nyan-cat.gif")
                //     left top
                //     no-repeat
                // `
                didOpen: (toast) => {
                    toast.onmouseenter = swalert.stopTimer;
                    toast.onmouseleave = swalert.resumeTimer;
                    // Swal.showLoading();
                    // const timer = Swal.getPopup().querySelector("b");
                    // timerInterval = setInterval(() => {
                    //     timer.textContent = `${swalert.getTimerLeft()}`;
                    // }, 100);
                },
                willClose: (result) => {
                    // clearInterval(timerInterval);
                    _G.alert.obj.onclose !== undefined ? _G.alert.obj.onclose(result) : () => { };
                }
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    // swalert.fire("Saved!", "", "success");
                    _G.alert.obj.yes !== undefined ? _G.alert.obj.yes(result) : () => { };
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // swalert.fire("Changes are not saved", "", "warning");
                    _G.alert.obj.no !== undefined ? _G.alert.obj.no(result) : () => { };
                }
                // } else if (result.isDenied) {
                //     swalert.fire("Changes are not saved", "", "info");
            });
        },
        success: (opt) => {
            _G.alert.obj.severity = 'success';
            // _G.alert.obj.toast = true;
            // _G.alert.obj.position = 'top-right';
            return _G.alert.notify(opt);
        },
        info: (opt) => {
            _G.alert.obj.severity = 'info';
            return _G.alert.notify(opt);
        },
        warning: (opt) => {
            _G.alert.obj.severity = 'warning';
            return _G.alert.notify(opt);
        },
        error: (opt) => {
            _G.alert.obj.severity = 'error';
            return _G.alert.notify(opt);
        },
        confirm: (opt) => {
            _G.alert.obj.severity = 'confirm';
            return _G.alert.notify(opt);
        },
        timer: (opt) => {
            _G.alert.obj.severity = 'info';
            return _G.alert.notify(opt);
        },
        close: (opt) => {
            swalert.close();
        },
    }),

    sortDictList: (arr, key, orderby) => {
        orderby = orderby === undefined ? 'asc' : orderby;
        arr = arr === undefined ? [] : arr;
        key = key === undefined ? 'length' : key;

        return orderby == 'desc' ? arr.sort((a, b) => {
            if (a[key] > b[key]) {
                return -1;
            }
            if (a[key] < b[key]) {
                return 1;
            }
            return 0;
        }) : arr.sort((a, b) => {
            if (a[key] < b[key]) {
                return -1;
            }
            if (a[key] > b[key]) {
                return 1;
            }
            return 0;
        });
    },

    sortList: (arr, orderby) => {
        orderby = orderby === undefined ? 'asc' : orderby;
        arr = arr === undefined ? [] : arr;

        return orderby == 'desc' ? arr.sort((a, b) => b - a) : arr.sort((a, b) => a - b);
    },

    uniqueId: (symlen) => {
        symlen = symlen ? symlen : 4;
        // if( arguments.length && arguments[0] ) symlen = arguments[0];
        // else symlen = 4;
        var symsize, pos, id = '', sym = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        symsize = sym.length;
        for (var i = 1; i <= symlen; i++) {
            pos = Math.floor(Math.random() * symsize);
            id += sym[pos];
        }
        return id;
    },

    uniqueDateId: () => {
        var id = '', sym = 'ABCDEFGHJK';
        let d1 = new Date().getTime();
        let d = parseInt(d1/1000).toString();
        for (var i = 0; i < d.length; i++) {
            id += sym[d[i]];
        }
        return (id + d1 % 1000 + _G.uniqueId(3)).toUpperCase();
    },

    decodeUniqueDateId: (data) => {
        var id = '', sym = 'ABCDEFGHJK';
        for (var i = 0; i < data.slice(0, -3).length; i++) {
            let a = sym.indexOf(data[i]);
            if( a != -1 ){
                id += a;
            }
            else{
                id += data[i];
            }
        }
        return id;
    },

    modalFormValidate: (frm) => {
        let a = frm.currentTarget.closest('.dynamicModal').querySelector('form').querySelectorAll('.required');
        a.forEach((b) => {
            if (b.value == '') {
                b.classList.add('required');
            }
        });
    },

    isFormValid: (fdata) => {
        let validated = true;
        fdata.table_columns.forEach((b) => {
            if (b.required !== undefined && b.required && (fdata[b.name] === undefined || fdata[b.name] == '')) {
                validated = false;
            }
        });
        return validated;
    },

    // capitalize: (txt) => {
    //     return txt
    //         .trim()
    //         .toLowerCase()
    //         .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));
    // },

    capitalize: str => str.charAt(0).toUpperCase() + str.slice(1),

    stripTags: str => str != '' ? str.replace(/(<[^>]*>)*/gm, '') : '',

    strip: (str, sym) => str != '' ? str.replace(new RegExp(`^${sym}+`, 'i'), '').replace(new RegExp(`${sym}+$`, 'i'), '') : '',

    token_data: () => {
        if (_G.hasClientData("AUTH_TOKEN"))
            return JSON.parse(atob(_G.getClientData('AUTH_TOKEN').split('.')[0]));
        else
            return {};
    },

    getByWordCount: (text, count) => {
        count = count !== undefined && count > 0 ? count : 12;
        let b = '';
        if(text.length){
            let a = text.split(' ');
            if(a.length > count) b = a.filter((e, i) => i < count).join(' ') + ' ...';
            else b = text;
        }
        return  b.length ? b : '';
    },

    userPageAccess: ref({}),

    privateIfNotPermission: (perm) => {
        if (perm !== undefined && perm != "" && _G.token_data()['role'] !== undefined) {
            return _G.userPageAccess.value[_G.token_data()['role']].filter((p) => p.route == _G.currentRoute.name && p.action && p.action.indexOf(perm) !== -1).length ? false : true;
            // return _G.userPageAccess.value.filter((f) => f.role === _G.token_data()['role'] && f.permission.filter((p) => p.route == _G.currentRoute.name && p.action && p.action.indexOf(perm) !== -1).length ).length ? false : true;
        }
        else return true;
    },
    userHavePermission: (perm, route) => {
        if (perm !== undefined && perm != "" && _G.token_data()['role'] !== undefined) {
            if( route === undefined ) route = _G.currentRoute.name;
            return _G.userPageAccess.value[_G.token_data()['role']].filter((p) => p.route == route && p.action && p.action.indexOf(perm) !== -1).length ? true : false;
            // return _G.userPageAccess.value.filter((f) => f.role === _G.token_data()['role'] && f.permission.filter((p) => p.route == _G.currentRoute.name && p.action && p.action.indexOf(perm) !== -1).length ).length ? true : false;
        }
        else return false;
    },
    privateIfNotAdmin: () => {
        return _G.token_data()['role'] != 'admin' ? true : false;
    },
    hideAdminRecord: (e) => {
        return (_G.token_data()['role'] != 'admin' && (e.slug == 'admin' || e.roles_id == 1)) ? true : false;
    },

    getUserAccessToMenu: (route) => {
        if (route !== undefined && route != "") {
            if( !_G.ignored_routes.includes(route) ){
                return _G.token_data() ? _G.userPageAccess.value[_G.token_data()['role']].filter((p) => p.route == route && p.action.indexOf('view') !== -1).length ? true : false : false;
                // return _G.token_data() ? _G.userPageAccess.value.filter((f) => f.role === _G.token_data()['role'] && f.permission.filter((p) => p.route == route && p.action.indexOf('view') !== -1).length).length ? true : false : false;
                // return _G.token_data()['role'] == 'admin' ? true : false;
            }
            else{
                return true;
            }
        }
        else return false;
    },

    formatSize: (bytes) => {
        const k = 1024;
        const dm = 3;
        const sizes = ['b', 'Kb', 'Mb', 'Gb', 'Tb'];

        if (bytes === 0) {
            return `0 ${sizes[0]}`;
        }

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

        return `${formattedSize} ${sizes[i]}`;
    },

    formatLocale: (value) => {
        if (value)
            return value.toLocaleString("az-AZ", {
                style: "currency",
                currency: "AZN",
                hour12: false,
                hourCycle: 'h24',
                // weekday: 'long',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
        else
            return value;
    },

    formatDateLocale: (value) => {
        if (value)
            return value.toLocaleDateString("az-AZ", {
                // style: "currency",
                // currency: "AZN",
                hour12: false,
                hourCycle: 'h24',
                // weekday: 'long',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
        else
            return value;
    },

    returnLocaleDate: (datestr, separator = '.') => {
        let ds = datestr.split(separator);

        let yearlit = {
            "00": "cü",
            "10": "cu",
            "20": "ci",
            "30": "cu",
            "40": "cı",
            "50": "ci",
            "60": "cı",
            "70": "ci",
            "80": "ci",
            "90": "cı",
        };


        let daylit = {
            "1": "ci",
            "2": "ci",
            "3": "cü",
            "4": "cü",
            "5": "ci",
            "6": "cı",
            "7": "ci",
            "8": "ci",
            "9": "cu",
            // "0": "cu",
        };
        let dayadvlit = {
            "10": "da",
            "20": "də",
            "30": "da",
        };
        // let day = str(int(datestr.strftime("%d")));
        let day = parseInt(ds[0]).toString();

        let monlit = {
            "1": "yanvar",
            "2": "fevral",
            "3": "mart",
            "4": "aprel",
            "5": "may",
            "6": "iyun",
            "7": "iyul",
            "8": "avqust",
            "9": "sentyabr",
            "10": "oktyabr",
            "11": "noyabr",
            "12": "dekabr",
        };

        let monadvlit = {
            "1": "ın",
            "2": "ın",
            "3": "ın",
            "4": "in",
            "5": "ın",
            "6": "un",
            "7": "un",
            "8": "un",
            "9": "ın",
            "10": "ın",
            "11": "ın",
            "12": "ın",
        };

        let month = parseInt(ds[1]).toString();
        let year = ds[2];

        // let lit = daylit[year[-1]] if year[-1] != '0' else yearlit['60']
        let lit = '';
        if( year.slice(-1) != '0')
            lit = daylit[year.slice(-1)];
        else
            lit = yearlit[year.slice(-2)];

        // return f'{year}-{lit} il {monlit[month]}ın {day}-' + ('da' if day[-1] in ['6','9'] else 'də')
        return `${year}-${lit} il ${monlit[month]}${monadvlit[month]} ${day}-` + ( dayadvlit[day.slice(-2)] !== undefined ? dayadvlit[day.slice(-2)] : (['6','9'].indexOf(day.slice(-1)) != -1 ? 'da' : 'də') )
    },

    parseDateAsObject: (diff) => {
        var milliseconds,seconds,minutes,hours,days,months,years;

        diff=(diff-(milliseconds=diff%1000))/1000;
        diff=(diff-(seconds=diff%60))/60;
        diff=(diff-(minutes=diff%60))/60;
        diff=(diff-(hours=diff%24))/24;
        diff=(diff-(days=diff%30))/30;
        years=(diff-(months=diff%12))/12;

        return [years, months, days, hours, minutes, seconds, milliseconds];
    },

    parseDateAsCount: (diff) => {
        var milliseconds,seconds,minutes,hours,days,months,years;

        milliseconds = diff%1000;
        seconds = Math.floor(diff/1000);
        minutes = Math.floor(diff/(1000*60));
        hours = Math.floor(diff/(1000*60*60));
        days = Math.floor(diff/(1000*60*60*24));
        months = Math.floor(diff/(1000*60*60*24*30));
        years = Math.floor(diff/(1000*60*60*24*30*12));

        return [years, months, days, hours, minutes, seconds, milliseconds];
        // return {
        //     'years': years,
        //     'months': months,
        //     'days': days,
        //     'hours': hours,
        //     'minutes': minutes,
        //     'seconds': seconds,
        //     'milliseconds': milliseconds,
        // };
    },

    calcDateFormat: (diff, ff, type) => {
        var years, months, days, hours, minutes, seconds, milliseconds;
        if( type == 'object' )
            [years, months, days, hours, minutes, seconds, milliseconds] = _G.parseDateAsObject(diff);
        else
            [years, months, days, hours, minutes, seconds, milliseconds] = _G.parseDateAsCount(diff);

        let f1 = {
            'yy': years,
            'MM': months,
            'dd': days,
            'hh': hours,
            'mm': minutes,
            'ss': seconds,
            'ms': milliseconds,
        };

        for(let a in ff){
            ff[a] = f1[a] != undefined ? ff[a].replace(/%s/i, '').replace(/%d/i, `${f1[a]}`) : ff[a].replace(/%s/i, '');
            // ff[a] = f1[a] != undefined ? ff[a].replace(/%s/i, '').replace(/%d([^>]*)/i, `${f1[a]}[$1]`) : ff[a];
        }
        return [ff, years, months, days, hours, minutes, seconds, milliseconds];
    },

    formatDateDuration: (opt) => {
        if( opt.obj && opt.date && opt.date != '' ){
            const opts = {
                // Main DayJS object
                obj: opt.obj || false,

                // DateTime for compute
                date: opt.date || false,

                // Show Past or Future character
                sign: opt.sign || false,

                // View as momentjs short date format
                short: opt.short || false,

                // Show as full months, years, days ...
                as: opt.as || false,

                years: opt.years !== undefined ? opt.years : true,
                months: opt.months !== undefined ? opt.months : true,
                days: opt.days !== undefined ? opt.days : true,
                hours: opt.hours !== undefined ? opt.hours : true,
                minutes: opt.minutes !== undefined ? opt.minutes : true,
                seconds: opt.seconds !== undefined ? opt.seconds : true,
                milli: opt.milli !== undefined ? opt.milli : false
            };

            let dateobj = opts.obj;

            var diff=dateobj().diff(dateobj(opts.date)).valueOf(), sign=diff<0?-1:1, milliseconds,seconds,minutes,hours,days,months,years, result;
            diff/=sign; // or diff=Math.abs(diff);

            if( opts.short !== undefined && opts.short == true ){
                return dateobj(opts.date).fromNow();
            }

            let lng = dateobj.locale();
            let f1 = {};
            let f2 = dateobj.localeData(lng)._relativeTime;

            let sec = f2['ss'].split(' ');

            // f1['ss'] = '%d ' + sec[sec.length-1];
            f1['ms'] = '%d milli' + sec[sec.length-1];

            let ff = Object.assign(f1, f2);

            if( opts.as === undefined || opts.as === false )
            {
                [ff, years, months, days, hours, minutes, seconds, milliseconds] = _G.calcDateFormat(diff, ff, 'object');

                result = [
                    opts.years !== undefined && opts.years == true && !!years && ff['yy'],
                    opts.months !== undefined && opts.months == true && !!months && ff['MM'],
                    opts.days !== undefined && opts.days == true && !!days && ff['dd'],
                    opts.hours !== undefined && opts.hours == true && !!hours && ff['hh'],
                    opts.minutes !== undefined && opts.minutes == true && !!minutes && ff['mm'],
                    opts.seconds !== undefined && opts.seconds == true && !!seconds && ff['ss'],
                    opts.milli !== undefined && opts.milli == true && !!milliseconds && ff['ms']
                ]
                .filter(Boolean)
                .join(' ');
            }
            else if(opts.as && opts.as !== '')
            {
                [ff, years, months, days, hours, minutes, seconds, milliseconds] = _G.calcDateFormat(diff, ff, 'count');

                let f3 = {
                    'year': ff['yy'],
                    'month': ff['MM'],
                    'day': ff['dd'],
                    'hour': ff['hh'],
                    'minute': ff['mm'],
                    'second': ff['ss'],
                    'millisecond': ff['ms'],

                    'years': ff['yy'],
                    'months': ff['MM'],
                    'days': ff['dd'],
                    'hours': ff['hh'],
                    'minutes': ff['mm'],
                    'seconds': ff['ss'],
                    'milliseconds': ff['ms'],
                };

                result = f3[opts.as];
            }

            // dynamicFormats.length ? '' : '';
            return result + (opts.sign !== undefined && opts.sign == true ? (opts.sign && sign < 0 ? ff['future'] : ff['past']) : '');
            // return new Date(years, months, days, hours, minutes, seconds, milliseconds); //.format(dynamicFormats) +
                // (opts.sign !== undefined && opts.sign == true ? (opts.sign && sign < 0 ? ff['future'] : ff['past']) : '')
                // : '';
        }
        else
            return '';
    },

    getErrorMessages: (data) => {
        let m = [];
        if (typeof data === 'object'){
            data.forEach((s) =>
                Object.keys(s).map((k) => { if (k != 'type') m.push(`${k} : ${s[k]}`); })
            );
        }
        else{
            m[0] = data;
        }

        return m.join("<br />");
    },


    hasClientData: (name) => {
        if (typeof (Storage) !== 'undefined' && localStorage[name]) return true;
        else return false;
    },
    setClientData: async (name, value) => {
        if (typeof (Storage) !== 'undefined') {
            localStorage.setItem(name, value);
            return true;
        }
        else {
            return false;
            // Sorry! No Web Storage support..
        }
    },
    getClientData: (name) => {
        if (typeof (Storage) !== 'undefined' && localStorage[name]) {
            return localStorage.getItem(name);
        }
        else {
            return false;
            // Sorry! No Web Storage support..
        }
    },
    removeClientData: (name) => {
        if (typeof (Storage) !== 'undefined' && localStorage[name]) {
            localStorage.removeItem(name);
            return true;
        }
        else {
            return false;
            // Sorry! No Web Storage support..
        }
    },
    is_mobile: () => {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return true;//"Windows Phone";
        }

        if (/android|KFAPWI/i.test(userAgent)) {
            return true;//"Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return true;//"iOS";
        }

        return false;
    },

    generateRandomSecurityKey: (min, max, codeNum) => {
        if( min == undefined ){
            min = 100;
        }
        if( max == undefined ){
            max = 999;
        }
        if( codeNum == undefined ){
            codeNum = 11;
        }
        let a = Math.floor(Math.random() * (max - min + 1) + min);
        let b = Math.floor(Math.random() * 9 + 1);
        let c = a << (b+codeNum);
        return `${c}${a}${b}`;
    },

    exf9: (str) => {
        str = str.toString();
        let size = 9;
        let es = [];
        let a = Math.floor(Math.random() * 9) + 11;
        for( let i=0; i < str.length; i++ ){
            let c = str[i].charCodeAt(0);
            let b = ((c << (a)) + 0).toString().padStart(size, '0');
            es.push( b );
        }
        return (a+14).toString().padStart(size, Math.random().toString().slice(2, (size - a.toString().length + 2)) ) + es.join('');
    },

    dxf9: (str) => {
        str = str.toString();
        let size = 9;
        let es = [];
        let b = Number(str.slice(size-2,size)) - 14;
        for( let i=size; i < str.length; i+=size ){
            let a = Number(str.slice(i, i+size).replace(/^[0]+/, '')) - 0 >> (b);
            es.push( String.fromCharCode( a ) );
        }
        return es.join('');
    },

    passString: {
        'A': 'oe',
        'B': 'wr',
        'C': 'bq',
        'D': 'a7',
        'E': 'm1',
        'F': 'mp',
        'G': 'v4',
        'H': 'u6',
        'I': 'xc',
        'J': '4p',
        'K': 'f8',
        'L': 'q2',
        'M': 'vn',
        'N': 'qt',
        'O': 'p5',
        'P': '3s',
        'Q': '%l',
        'R': 'w$',
        'S': 'a@',
        'T': '!&',
        'U': '(c',
        'V': 'vf',
        'W': 'p0',
        'X': '$-',
        'Y': 'v&',
        'Z': 'c*',
        'Ü': 'w#',
        'Ö': '%t',
        'Ğ': 'Fg',
        'İ': '@d',
        'Ə': 'Hn',
        'Ç': 'V^',
        'Ş': 'J*',
        '1': 'q@',
        '2': '02',
        '3': '.&',
        '4': 'w!',
        '5': '|q',
        '6': 'l|',
        '7': ')?',
        '8': '>s',
        '9': 's^',
        '0': ';&',
        'a': '$c',
        'b': '-g',
        'c': '|*',
        'd': '1-',
        'e': '>:',
        'f': '+x',
        'g': '^a',
        'h': ']E',
        'i': 'P0',
        'j': '{1',
        'k': 'cW',
        'l': 'Dc',
        'm': '*!',
        'n': 'W-',
        'o': '.?',
        'p': '%<',
        'q': ':a',
        'r': '&c',
        's': 'WY',
        't': '{h',
        'u': '_%',
        'v': '}$',
        'w': 'lU',
        'x': 'I^',
        'y': 'lP',
        'z': '.#',
        'ü': 'P(',
        'ö': ':)',
        'ğ': 'L_',
        'ı': 'I&',
        'ə': 'Y%',
        'ç': '{_',
        'ş': '>&',
        '!': '%-',
        '@': 'Y,',
        '#': '%B',
        '$': '*v',
        '%': ')T',
        '^': ';R',
        '&': 'G_',
        '*': '/e',
        '(': 'G%',
        ')': '*F',
        '_': '@*',
        '-': 'Hc',
        '=': '&D',
        '+': '(#',
        '[': 'lW',
        ']': ')Q',
        '{': 'D>',
        '}': '+%',
        ':': 's:',
        ';': '^(',
        ',': '&?',
        '.': 'G7',
        '<': 'K*',
        '>': 'L^',
        '/': '4C',
        '?': '#9',
        '|': '_@',
        ' ': '#B'
    },

    aEncrypt: (iStr, cryptCount) => {
        if (cryptCount === undefined) {
            cryptCount = 2;
        }
        iStr = iStr.toString();
        let o = '';
        if (iStr != '' && _G.passString != null) {
            for (var i = 0; i < cryptCount; i++) {
                for (var j = 0; j < iStr.length; j++) {
                    o += _G.passString[iStr.substring(j, j + 1)];
                }
                iStr = o;
                o = '';
            }
        }
        return iStr;
    },

    aDecrypt: (iStr, cryptCount) => {
        if (cryptCount === undefined) {
            cryptCount = 2;
        }
        iStr = iStr.toString();
        let o = '';
        if (iStr != '' && _G.passString != null) {
            for (var i = 0; i < cryptCount; i++) {
                for (var j = 0; j < iStr.length; j += 2) {
                    for(let a in _G.passString){
                        if (_G.passString[a] == iStr.substring(j, j + 2)) {
                            o += a;
                        }
                    }
                    // _G.passString.forEach((key, val) => {
                    //     if (val == iStr.substring(j, j + 2)) {
                    //         o += key;
                    //     }
                    // });
                }
                iStr = o;
                o = '';
            }
        }
        return iStr;
    },

    secretKey: "qwerqwerasdfzxcv", // Must be 16, 24, or 32 bytes for AES

    // // Encrypt data
    // encryptData: (data) => {
    //     const encrypted = CryptoJS.AES.encrypt(
    //     JSON.stringify(data),
    //     CryptoJS.enc.Utf8.parse(_G.secretKey),
    //     { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
    //     );
    //     return encrypted.toString();
    // },

    // // Decrypt response data
    // decryptData: (encryptedText) => {
    //     const decrypted = CryptoJS.AES.decrypt(
    //         encryptedText,
    //         CryptoJS.enc.Utf8.parse(_G.secretKey),
    //         { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
    //     );
    //     return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    // },

    componentToHex: (c) => {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    },
    rgbToHex: (r, g, b) => {
        return "#" + _G.componentToHex(r) + _G.componentToHex(g) + _G.componentToHex(b);
    },

    parseTokenPermission: () => {
        const t = _G.token_data();
        if( t instanceof Object ){
            let perm = JSON.parse(t.permission || '[]')
            // _G.userPageAccess.value = [];
            _G.userPageAccess.value[t.role] = perm.permission || perm || [];

            // _G.userPageAccess.value.push({
            //     'role': t.role || '',
            //     'permission': perm.permission || perm || [],
            // });
        }
    },

    parsePermission: (role, permission) => {
        let perm = JSON.parse(permission || '[]')
        // _G.userPageAccess.value = [];
        // let bRole = false;
        // _G.userPageAccess.value.forEach(r => {
        //         if(r.role == role){
        //             r.permission = perm;
        //             bRole = true;
        //         }
        //     }
        // );
        // if( !bRole ){
        //     _G.userPageAccess.value.push({
        //         'role': role || '',
        //         'permission': perm || [],
        //     });
        // }
        _G.userPageAccess.value[role] = perm || [];

        // console.log(_G.userPageAccess.value);
    },

    dateToStr: (date, format) => {
        if( date != null && date != '' && format != '' ){
            if( typeof date != 'string'){
                date = moment(date).format(_G.datetime_format['datetime_as_pg']);
            }
            date = date.split("+").length > 1 && date.split("+")[1].length > 5 ? date.slice(0, -3) : date;
            return moment.utc(date).tz(_G.systemData?.timezone?.value).format(_G.datetime_format[format]);
        }
        else{
            return '';
        }
    },

    strToDate: (date, now) => {
        if( date != null && date != ''){
            if( typeof date != 'string'){
                date = moment(date).format(_G.datetime_format['datetime_as_pg']);
            }
            date = date.split("+").length > 1 && date.split("+")[1].length > 5 ? date.slice(0, -3) : date;
            return moment.utc(date).tz(_G.systemData?.timezone?.value).toDate();
        }
        else if( now !== undefined && now == true ){
            return moment().toDate();
        }
        else{
            return null;
        }
    },

    escapeRegex: (str) => {
        if (str == null) return '';
        return str.replace(/[-.*+?^${}()|[\]\\]/g, '\\$&');
    }
}

//
_G.token = (_G.hasClientData("AUTH_TOKEN")) ? _G.getClientData("AUTH_TOKEN") : "";

if( _G.userImage.value == '' ){
    _G.userImage.value = _G.token_data().image;
}

_G.parseTokenPermission();
// console.log(_G.userPageAccess.value);


